import React, { useEffect, useState, useRef } from 'react';
import { Grid, Dialog, ListItem } from '@material-ui/core';
import { Text, Avatar } from 'library';
import { client, consoleLogInDev } from 'shared';
import { IShareableProvider } from './models';

const ProviderSelection = ({
    open,
    onClose,
    selectProvider,
}: {
    open: boolean;
    onClose: () => void;
    selectProvider: (e: IShareableProvider) => void;
}) => {
    const [providers, setProviders] = useState<IShareableProvider[]>();
    const scrollElementRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        getShareableProviders();
    }, []);

    const getShareableProviders = () => {
        client('api/shareable-providers/')
            .then((response) => setProviders(response))
            .catch(consoleLogInDev);
    };

    const noShareableProviders = () => {
        return (
            <Grid lg={12} style={{ paddingLeft: 20 }}>
                <Text variant="body1">Providers you have messaged will display here for you to share.</Text>
            </Grid>
        );
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth={'sm'}
            fullWidth={true}
            PaperProps={{
                style: {
                    borderRadius: 20,
                    padding: 16,
                },
            }}
        >
            <Grid style={{ padding: 20 }}>
                <Text variant="h1" bold={true}>
                    Share Provider
                </Text>
            </Grid>
            <Grid container justify="center" ref={scrollElementRef} style={{ overflow: 'auto', maxHeight: 940 }}>
                {!!providers && providers.length > 0
                    ? providers.map((provider) => (
                          <ListItem
                              button
                              divider
                              onClick={() => {
                                  onClose();
                                  selectProvider(provider);
                              }}
                          >
                              <Grid container item alignItems="center" justify="center">
                                  {provider.profile_picture.image ? (
                                      <img
                                          src={provider.profile_picture.image}
                                          alt={provider.profile_picture.title}
                                          style={{
                                              width: 70,
                                              height: 70,
                                              borderRadius: '50%',
                                          }}
                                      />
                                  ) : (
                                      <Avatar index={Math.floor(Math.random() * 4)} />
                                  )}
                              </Grid>
                              <Grid container direction="column">
                                  <Text variant={'body1'}>{provider.name}</Text>
                              </Grid>
                          </ListItem>
                      ))
                    : noShareableProviders()}
            </Grid>
        </Dialog>
    );
};

export default ProviderSelection;
